import React, { Component } from 'react';
import PropTypes from 'prop-types';

class RKPayRibbon extends Component {
	shouldComponentUpdate = ({ size }) => {
		const lastProps = this.props;
		return (
			size !== lastProps.size
		);
	}

	render() {
		const { size } = this.props;

		return (
			<div
				data-prevent-navigation
				className="rkpay-ribbon-wrapper"
			>
				<img
					src={`/images/ribbon-${size}.png`}
					className="rkpay-ribbon"
					alt="rkpay ribbon"
				/>
			</div>
		);
	}
}

RKPayRibbon.propTypes = {
	size : PropTypes.oneOf([
		'sm',
		'md',
		'lg',
	]),
};

RKPayRibbon.defaultProps = {
	size : 'sm',
};

export default RKPayRibbon;
